import React from 'react';
import IconChevronDown from '../../resources/icons/IconChevronDown.svg';
export const SingleSelect = _ref => {
  let {
    setFilterDropdownState,
    setFilterChoiceState,
    resetFilterChoiceState,
    items,
    filters,
    isOpen,
    label,
    filterName,
    resultsAmount,
    clearAllLabel,
    showNResultsLabel
  } = _ref;
  const [currentState, setCurrentState] = React.useState({});
  const [slectedValue, setSlectedValue] = React.useState('');
  React.useEffect(() => {
    const cur = {};
    Object.keys(items).forEach(key => {
      const selected = filters.includes(key);
      cur[key] = selected;
      selected && setSlectedValue(key);
    });
    setCurrentState(cur);
  }, [items, filters]);
  const toggleFilter = e => {
    setFilterDropdownState(!isOpen, filterName);
    e.preventDefault();
  };
  const sendFilter = e => {
    setFilterChoiceState(true, slectedValue, filterName, true);
    setFilterDropdownState(!isOpen, filterName);
    e.preventDefault();
  };
  const clearFilter = e => {
    resetFilterChoiceState(filterName);
    e.preventDefault();
  };
  const itemToggle = value => {
    setSlectedValue(value);
    setCurrentState(prev => {
      for (const prevKey in prev) {
        if (value === prevKey) {
          prev[value] = true;
        } else {
          prev[prevKey] = false;
        }
      }
      return prev;
    });
  };

  // If you check some facet - recalculate amount of results to be shown.
  const amountToBeShown = filters.length ? Object.keys(items).reduce((amount, key) => {
    if (filters.includes(key)) {
      return amount + items[key];
    }
    return amount;
  }, 0) : resultsAmount;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field"
  }, /*#__PURE__*/React.createElement("div", {
    className: `filter-panel eloqua ${isOpen ? 'filter-panel--open' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: `filter-panel__box ${isOpen ? 'filter-panel__box--openedDrop' : ''}`
  }, /*#__PURE__*/React.createElement("a", {
    className: "filter-panel__trigger js-filter-panel__trigger",
    href: "/#",
    onClick: toggleFilter,
    "aria-label": "Filter Name",
    "aria-labelledby": "Filter Name"
  }, label || filterName), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, filters && filters.length ? filters.join(',') : label || filterName), /*#__PURE__*/React.createElement("img", {
    className: "icon",
    src: IconChevronDown,
    alt: "Expand down",
    "aria-disabled": true
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fp__inner-cb"
  }, /*#__PURE__*/React.createElement("a", {
    className: "body-medium fp__inner-clear",
    href: "/#",
    onClick: clearFilter,
    "aria-label": "Clear All",
    "aria-labelledby": "Clear All"
  }, clearAllLabel)), Object.keys(items).map(key => {
    return /*#__PURE__*/React.createElement("label", {
      className: "checkbox-aligned fp__inner-label",
      htmlFor: key.replace(/\s/g, '_'),
      key: key
    }, /*#__PURE__*/React.createElement("input", {
      checked: currentState[key],
      className: "input-choice input-single fp__radio",
      type: "radio",
      name: filterName,
      value: key,
      id: key.replace(/\s/g, '_'),
      onChange: () => itemToggle(key)
    }), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-text"
    }, key, " (", items[key], ")"), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-bg"
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__bottom "
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary js-btn-close-panel",
    onClick: sendFilter
  }, showNResultsLabel.replace('{#resultsAmount#}', '')))))));
};
export default SingleSelect;